// routes.ts

export const HOME_ROUTE = '/';

export const CLIENTS_ROUTE = '/clients';
export const ARCHIVED_CLIENTS_ROUTE = '/archived-clients';

export const CLIENT_ROUTE = '/clients/:groupid?/:groupname?/:id';
export const CLIENT_NOTES_ROUTE = '/clients/:groupid?/:groupname?/:id?tab=notes';
export const CLIENT_PROGRESS_ROUTE = '/clients/:groupid?/:groupname?/:id?tab=progress';
export const CLIENT_ACTIVITIES_ROUTE = '/clients/:groupid?/:groupname?/:id?tab=activities';
export const CLIENT_DETAILS_ROUTE = '/clients/:groupid?/:groupname?/:id?tab=client-details';

export const APPOINTMENTS_ROUTE = '/appointments';

export const ACTIVITY_LIBRARY_ROUTE = '/activity-library';

export const CHAT_ROUTE = '/chat';

export const SETTINGS_ROUTE = '/settings';
export const PERSONAL_INFO_ROUTE = '/settings/personal-info';
export const CHANGE_PASSWORD_ROUTE = '/settings/change-password';
export const PAYMENT_DETAILS_ROUTE = '/settings/payment-details';

export const LOGIN_ROUTE = '/auth/login';
export const AFFILIATE_LOGIN_ROUTE = '/auth/login/:affiliate';
export const SIGNUP_ROUTE = '/auth/sign-up';
export const AFFILIATE_SIGNUP_ROUTE = '/auth/sign-up/:affiliate';

export const ADD_NEW_APPOINTMENT_ROUTE = '/appointments/new';

export const NOTIFICATION_ROUTE = '/notifications';

export const FORGOT_PASSWORD_ROUTE = '/auth/forgot-password';
export const AFFILIATE_FORGOT_PASSWORD_ROUTE = '/auth/forgot-password/:affiliate';

export const ADMIN_DASHBOARD_ROUTE = '/dasboard';
export const MANAGE_ADMINS_ROUTE = '/manage-admins';
export const ORGANISATIONS_ROUTE = '/organisation';
export const APPLICATIONS_ROUTE = '/applications';
export const ADD_NEW_COACH_ROUTE = '/coach/new';
export const COACHES_ROUTE = '/coaches';
export const ARCHIVED_COACHES_ROUTE = '/archived-coaches';
export const COACH_ONBOARDING_ROUTE = '/auth/coachOnboarding';

export const COACH_SIGNUP_WITH_EMAIL_ROUTE = '/auth/sign-up/email';
export const AFFILIATE_COACH_SIGNUP_WITH_EMAIL_ROUTE = '/auth/sign-up/email/:affiliate';
export const EMAIL_VERIFICATION_ROUTE = '/auth/email-verification';
export const AFFILIATE_EMAIL_VERIFICATION_ROUTE = '/auth/email-verification/:affiliate';
export const ONBOARDING_ROUTE = '/onboarding';

export const USER_GROUPS_ROUTE = '/user-groups';

export const PAYMENT_SETTINGS_ROUTE = '/payment-settings';
export const PAYMENT_INFO_ROUTE = '/payment-info';
export const PAYMENT_SUCCESS_ROUTE = '/purchase-success';
export const CHECKOUT_PAGE_ROUTE = '/checkout';
export const SUBSCRIPTION_PLANS = '/subscription-plans';

export const VIEW_BOOKINGS_ROUTE = '/view-bookings';
export const SUCCESS_BOOKING_SETUP_ROUTE = '/success-booking-setup';
export const CALENDAR_SETTINGS_ROUTE = '/booking-settings';
export const BOOKING_SESSIONS_ROUTE = '/booking-sessions';

export const COACH_PROFILE_ROUTE = '/u/:username';
export const COACH_BOOKING_CONFIRMATION = '/u/:username/confirmation';
export const NOT_FOUND_ROUTE = '/not-found';
export const COACH_PROFILE_SET_BOOKING_DATE_ROUTE = '/u/:username/set-booking-date';
export const COACH_PROFILE_SET_BOOKING_TIME_ROUTE = '/u/:username/set-booking-time';
export const COACH_PROFILE_SET_BOOKING_DETAILS_ROUTE = '/u/:username/set-booking-details';

export const MANAGE_TEAM_ROUTE = '/manage-team';
export const CREATE_PASSWORD_ROUTE = 'auth/create-password';
export const TEAM_CLIENTS_ROUTE = '/manage-team/:id?';
